var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.crumpList)?_c('div',{staticClass:"wrappCrump"},_vm._l((_vm.crumpList),function(crump,index){return _c('div',{key:index,class:{
            active: _vm.selected.id === crump.id, 
            crump: true
        },on:{"click":function($event){return _vm.selectCrump(crump)}}},[_vm._v(" "+_vm._s(crump.label)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }